import { render } from "./TmsSyncedBadge.vue?vue&type=template&id=171c40ac&scoped=true"
import script from "./TmsSyncedBadge.vue?vue&type=script&lang=js"
export * from "./TmsSyncedBadge.vue?vue&type=script&lang=js"

import "./TmsSyncedBadge.vue?vue&type=style&index=0&id=171c40ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-171c40ac"]])

export default __exports__